import { DeliveryMarker } from '@gozoki/ui/components/supply/supply-icons'
import { BarsMark, DashedMark } from '@gozoki/ui/components/supply/supply-legend-marks'
import type { ReactNode } from 'react'

// Couleurs de la maquette store-app (Figma 10781:27100). Deux d'entre elles diffèrent de
// SUPPLY_LEGEND_COLORS (@gozoki/ui) : les toucher là-bas déplacerait aussi les barres du graphe
// et la légende du back-office, donc elles restent locales à cet écran.
const LEGEND_COLORS = {
  stocks: '#B3C8AD',
  defectiveStocks: '#79627B',
  sales: '#EFA031',
  forecastSales: '#526D4A',
  correctedSales: '#F5C27A',
  delivery: '#5E7D4F',
  deliveryMark: '#6A9560',
} as const

interface LegendEntry {
  key: string
  label: string
  color: string
  mark: ReactNode
}

// Pas d'entrée « Ordres » ici : la maquette boutique n'en affiche que six.
const LEGEND_ENTRIES: LegendEntry[] = [
  {
    key: 'stocks',
    label: 'Stocks',
    color: LEGEND_COLORS.stocks,
    mark: <BarsMark color={LEGEND_COLORS.stocks} rising={false} />,
  },
  {
    key: 'defectiveStocks',
    label: 'Stocks défectueux',
    color: LEGEND_COLORS.defectiveStocks,
    mark: <BarsMark color={LEGEND_COLORS.defectiveStocks} rising={false} />,
  },
  {
    key: 'sales',
    label: 'Ventes',
    color: LEGEND_COLORS.sales,
    mark: <BarsMark color={LEGEND_COLORS.sales} rising />,
  },
  {
    key: 'forecastSales',
    label: 'Prévisions ventes',
    color: LEGEND_COLORS.forecastSales,
    mark: <DashedMark color={LEGEND_COLORS.forecastSales} />,
  },
  {
    key: 'correctedSales',
    label: 'Vente corrigée',
    color: LEGEND_COLORS.correctedSales,
    mark: <BarsMark color={LEGEND_COLORS.correctedSales} rising />,
  },
  {
    key: 'delivery',
    label: 'Livraison',
    color: LEGEND_COLORS.delivery,
    mark: (
      <span style={{ color: LEGEND_COLORS.deliveryMark }}>
        <DeliveryMarker size={14} />
      </span>
    ),
  },
]

export function SupplyLegend() {
  return (
    <div className="flex shrink-0 items-center gap-[16px]">
      {LEGEND_ENTRIES.map((entry) => (
        <span
          key={entry.key}
          className="flex items-center gap-[8px] font-sans text-[12px] leading-none font-semibold uppercase"
          style={{ color: entry.color }}
        >
          {entry.mark}
          {entry.label}
        </span>
      ))}
    </div>
  )
}
